type UserProgramType = { label?: string; value: string };

type LoginUserData = {
  userProgramTypes?: UserProgramType[];
  redgateUserInfoV2?: {
    data?: {
      userAccesses?: Array<{ programType?: string; roleName?: string }>;
    };
  };
};

export const PROGRAMME_TYPE_STORAGE_KEY = "finbox-dashboard-programme-type";
export const ROLE_NAME_STORAGE_KEY = "finbox-dashboard-role-name";

const DEFAULT_PROGRAMME_TYPE = "LAP";

/**
 * Picks the default programme type for a set of user program types: if the
 * user has access to LAP, LAP wins; otherwise fall back to the first program
 * type. Used both when persisting the value on login and when defaulting the
 * MyQueue selection on a fresh open.
 */
export const getDefaultProgrammeTypeValue = (
  userProgramTypes?: UserProgramType[]
): string | undefined => {
  if (!userProgramTypes?.length) return undefined;

  const lapProgrammeType = userProgramTypes.find(
    (programType) => programType.value?.toUpperCase() === DEFAULT_PROGRAMME_TYPE
  );

  return lapProgrammeType?.value ?? userProgramTypes[0].value;
};

export const getProgrammeTypeFromLoginUserData = (
  loginUserData?: LoginUserData
): string | undefined => {
  const defaultProgrammeType = getDefaultProgrammeTypeValue(
    loginUserData?.userProgramTypes
  );
  if (defaultProgrammeType) return defaultProgrammeType;

  return loginUserData?.redgateUserInfoV2?.data?.userAccesses?.[0]?.programType;
};

export const setStoredProgrammeType = (loginUserData?: LoginUserData) => {
  const programmeType = getProgrammeTypeFromLoginUserData(loginUserData);

  if (programmeType) setStoredProgrammeTypeValue(programmeType);
};

export const setRoleName = (loginUserData?: LoginUserData) => {
  const roleName =
    loginUserData?.redgateUserInfoV2?.data?.userAccesses?.[0]?.roleName;
  if (roleName) {
    localStorage.setItem(ROLE_NAME_STORAGE_KEY, roleName);
  }
};

export const setStoredProgrammeTypeValue = (programmeType: string) => {
  if (programmeType) {
    localStorage.setItem(PROGRAMME_TYPE_STORAGE_KEY, programmeType);
  }
};

export const getStoredProgrammeType = (): string | undefined =>
  localStorage.getItem(PROGRAMME_TYPE_STORAGE_KEY) || undefined;

export const getStoredRoleName = (): string | undefined =>
  localStorage.getItem(ROLE_NAME_STORAGE_KEY) || undefined;
